<template>
  <div class="privacy-container">
    <div class="section-container">
      <div class="title-box">
        <p>隐私政策 Privacy Policy</p>
      </div>
      <p class="tip">
        保护您个人数据的安全与隐私对于本网站来说十分重要，因此，我们严格遵守数据隐私保护与数据安全的相关法律。通过下面列出的条款，我们希望能够帮助您了解本网站需要收集哪些数据、怎样使用和保护这些数据、以及和哪些人共享这些数据。
      </p>
      <el-row class="mt90 content-box">
        <el-col :span="12">
          <p class="content-title">•&nbsp;使用目的</p>
          <p>
            您通过本网站提供的个人信息，我们通常用来回复你的询问、处理您的订单或为您提供相关信息或者方案。我们还会利用这些信息来支持与您的客户关系。我们存储并处理这些个人数据，以便更好的了解您的业务需求、改进我们的产品和服务；或者我们（或代表我们的第三方机构）会使用这些个人信息联系您，提供支持您业务需求的方案，或进行在线调查，更好的理解客户的需求。
          </p>
        </el-col>
        <el-col :span="12">
          <p class="content-title">•&nbsp;目的的限定</p>
          <p>本网站会收集您在网上提供的个人数据，仅限于以下原因：</p>
          <p>
            *为了某种附加目的而对这些个人数据的使用，这些附加的目的直接与收集个人数据的原始目的相关；
          </p>
          <p>*准备、协商并履行与您的合同所需要的；</p>
          <p>*法律、政府或司法机关所要求的；</p>
          <p>*法律声明或辩护所需要的；</p>
          <p>
            *避免欺诈行为或其它活动所需要的，如对四川新希望房地产开发有限公司信息技术系统的故意攻击。
          </p>
        </el-col>
        <el-col :span="12">
          <p class="content-title">•&nbsp;非个人信息的自动收集</p>
          <p>
            当您访问我们的网站时，我们可能会自动（如：不通过注册）收集一些非个人的数据（如：使用的Internet浏览器和操作系统、您的网站域名、访问数量、平均在线时间、访问的页面）。我们可能会使用这些数据，并将其与附属机构共享，以监测我们的网站受欢迎度。
          </p>
        </el-col>
        <el-col :span="12">
          <p class="content-title">•&nbsp;安全</p>
          <p>
            为保护您的个人数据不受偶然和非法的破坏、损失、更改，以及未经许可的公开和访问，本网站使用了技术上以及组织上的安全手段。
          </p>
        </el-col>
      </el-row>

      <div class="footer-text">以上声明内容的解释权归本网站所有</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PrivacyPage",
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.privacy-container {
  .title-box {
    padding: 71px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #6d7173;
    line-height: 35px;
    font-size: 30px;
    color: #3c4347;
  }

  .tip {
    margin-top: 66px;
    text-align: justify;
    font-size: 14px;
    color: #7a7a7a;
    line-height: 22px;
  }

  .mt90 {
    margin-top: 90px;
  }

  .content-box {
    > div {
      box-sizing: border-box;
      height: 400px;
      padding-top: 50px;
      border-bottom: 1px dashed #7a7a7a;

      > p:nth-child(1n + 2) {
        font-size: 14px;
        color: #7a7a7a;
        line-height: 26px;
        margin-bottom: 8px;
        text-align: justify;
      }
    }
    > div:nth-child(2n + 1) {
      border-right: 1px dashed #7a7a7a;
      padding-right: 60px;
    }

    > div:nth-child(2n + 2) {
      padding-left: 60px;
    }
  }

  .content-title {
    font-size: 28px;
    color: #3c4347;
    line-height: 30px;
    margin-bottom: 25px;
  }

  .mt60 {
    margin-top: 60px;
  }

  .footer-text {
    font-size: 20px;
    color: #3c4347;
    margin-top: 28px;
  }
}
</style>
